/**
 * @file Socials.js
 * @author Stanley Chen
 * @description Fixed social media sidebar component that displays links to
 * Kiku's social media profiles with animated icons
 */

import OutboundLink from '../OutboundLink';
import './Socials.css';

const Socials = () => {
    return (
      <div className="social-sidebar">
        <OutboundLink 
          href="https://www.facebook.com/KikuMiddletown/" 
          label="Facebook (Floating Sidebar)"
          aria-label="Visit our Facebook page"
        >
          <i className="fab fa-facebook-f" />
        </OutboundLink>
        <OutboundLink 
          href="https://www.yelp.com/biz/kiku-middletown-2?utm_campaign=www_business_share_popup&utm_medium=copy_link&utm_source=(direct)" 
          label="Yelp (Floating Sidebar)"
          aria-label="Visit our Yelp page"
        >
          <i className="fab fa-yelp" />
        </OutboundLink>
      </div>
    );
  };
  
  export default Socials;